// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class QuoteModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    let color = this.instance["options"]["color"];

    if (color) {
      return color;
    }

    return "black";
  }

  get getColSize() {
    let colSize = parseInt(this.instance["options"]["col"]);
    return colSize;
  }
}
